import moment from 'moment';

export const formatDuration = (seconds: number) => {
    const duration = moment.duration(seconds, 'seconds');
    const hours = duration.hours();
    const minutes = duration.minutes();
    const secs = duration.seconds();

    let parts = [];

    if (hours > 0) {
        parts.push(hours === 1 ? '1 hr' : `${hours} hrs`);
    }

    if (minutes > 0) {
        parts.push(minutes === 1 ? '1 min' : `${minutes} mins`);
    }

    if (hours === 0 && minutes === 0 && secs > 0) {
        parts.push(secs === 1 ? '1 sec' : `${secs} secs`);
    }

    return parts.join(' ');
};